// extracted by mini-css-extract-plugin
module.exports = {"header":"form_header__2kQpO","container":"form_container__1To3P"};